<template>
    <div class="acountStatus"> 
        <div class="mainTitle text-center my-4">
            <message-component :message="response_msg" :messageType="msg_type"></message-component>
        </div>
        <!-- Modal -->
        <!-- <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" v-show="parseInt(get_user.verified_status) != 2" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header p-0 border-bottom-0">
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body py-1">
                        <div class="otpBlock text-center">
                            <img width="100" height="100" src="../../../../static/fxView/images/registerflow-new/check.gif" alt="Congratulations" />
                            <div class="mb-4">
                                <h2 class="f-30 mb-3">{{ $t('fxDepositSuccess') }}</h2>
                                <h4 class="green f-26">{{ depositList.records[0].currency }} {{ depositList.records[0].amount }}</h4>
                            </div>
                            <div class="whitebox p-0 m-0">
                                <div class="text-center innerTitle pb-3">
                                <h2 class="mb-2 f-18 medium">{{$t('fxChoosePlatform')}}</h2>
                            </div>
                                <div class="downloadPlatform d-flex align-items-center">
                                    <div class="dpBox d-flex align-items-center">
                                        <a :href="$env_var.downloadPlatformLink1[depositList.records[0].platform.toUpperCase()].window"
                                            target="_blank">
                                            <div class="ico">
                                                <img src="../../../../static/fxView/images/windows.svg" alt="" />
                                            </div>
                                            <div class="desc">
                                                <p>{{$t('fxWindow')}}</p>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="dpBox d-flex align-items-center">
                                        <a :href="$env_var.downloadPlatformLink1[depositList.records[0].platform.toUpperCase()].ios"
                                            target="_blank">
                                            <div class="ico">
                                                <img src="../../../../static/fxView/images/ios.svg" alt="" />
                                            </div>
                                            <div class="desc">
                                                <p>{{$t('fxIOS')}}</p>
                                            </div>
                                        </a>
                                    </div>
                                    <div v-if="platform != 'ACT'" class="dpBox d-flex align-items-center">
                                        <a :href="$env_var.downloadPlatformLink1[depositList.records[0].platform.toUpperCase()].mac"
                                            target="_blank">
                                            <div class="ico">
                                                <img src="../../../../static/fxView/images/mac_ico.svg" alt="" />
                                            </div>
                                            <div class="desc">
                                                <p>{{$t('fxMac')}}</p>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="whiteBG radius pt-3"> 
            <div class="d-flex flex-wrap tabcenter justify-content-between border-bottom pb-3 px-3 mb-2 align-items-center"> 
                <div><h2 class="mb-0">{{$t('dl_depositList')}}</h2></div>
                <div class="requestbtn commanfilter d-flex align-items-center">
                   <filter-component></filter-component>  
                </div>   
            </div>
            <div class="inMiddle-area table-responsive ">
                <table class="table pmmTable">
                    <thead>
                        <tr>
							<th>{{$t('dl_transId')}}</th>
							<th>{{$t('dep_acc_fund_accountId')}}</th>
                            <th>{{$t('req_amount')}}</th>
							<th>{{$t('dash_currency')}}</th>
                            <th>{{$t('dl_status')}}</th>
							<th>{{$t('dl_Method')}}</th>
							<th>{{$t('dl_type')}}</th>
							<th>{{$t('dl_created')}}</th>
							<th>{{$t('dl_action')}}</th>
                        </tr>
                    </thead>
                    <tbody v-if="(!pageLoader && depositList != '' && depositList.totalRecords > 0)">
                        <tr v-for="list in depositList.records" >
							<td>
                                <span v-if="list.deposit_method != '' && list.deposit_method != null && parseInt(list.deposit_method) == 18">{{list.internal_tx_id}} </span>
                                <span v-else>{{list.transaction_id}} </span>
                            </td>
                            <td><p v-html="(list.wallet_no != '' && list.wallet_no != null && list.wallet_no != undefined)? list.wallet_no  : list.account_id"></p> </td>
                            <td>{{parseFloat(list.amount).toFixed(2)}}</td>
                            <td>
                                <img :src="'../../../../static/fxView/images/'+$env_var.currencyImages[list.currency.toUpperCase()]" class="data_currency rounded-circle" v-if="$env_var.currencyImages[list.currency.toUpperCase()]">
                                <div class="data_currency rounded-circle noImage" v-else>{{ list.currency.toUpperCase() }}</div>
                            </td>
                            <td>
								<span v-if="list.payment_status == '' || list.payment_status == null">-</span>
								<span class="badge badge-pill badge-warning" v-if="parseInt(list.payment_status) == -1 || parseInt(list.payment_status) == 0">{{$env_var.paymentStatus[list.payment_status]}}</span>
								<span class="badge badge-pill badge-danger" v-if="parseInt(list.payment_status) == 2 || parseInt(list.payment_status) == 3 || parseInt(list.payment_status) == 4">{{$env_var.paymentStatus[list.payment_status]}}</span>
								<span class="badge badge-pill badge-success" v-if="parseInt(list.payment_status) == 1">{{$env_var.paymentStatus[list.payment_status]}}</span>
                                <span class="badge badge-pill badge-warning" v-if="parseInt(list.payment_status) == 5">{{$env_var.paymentStatus[list.payment_status]}}</span>
                            </td>
                            <td>
                                <p v-if="list.deposit_method != '' && list.deposit_method != null ">
                                    <!-- {{ depositMethod[list.deposit_method]}} -->
                                    {{(parseInt(list.deposit_method) == 28 || parseInt(list.deposit_method) == 29) ? 'Bank' : $env_var.depositMethod[list.deposit_method]}}
                                    <span v-if="parseInt(list.deposit_method) == 18">
                                    ({{list.dep_curr}})
                                    </span>
                                </p>
                                <p v-else>-</p>
                            </td>
							<!-- <td v-html="(list.deposit_method != '' && list.deposit_method != null)
                                ?
                                (parseInt(list.deposit_method) == 28 || parseInt(list.deposit_method) == 29) ? 'Bank' : $env_var.depositMethod[list.deposit_method]
                                :
                                '-'">
                            </td> -->
							<td v-html="(list.deposit_type != '' && list.deposit_type != null)?$env_var.depositType[list.deposit_type] : '-'"></td>
							<td>{{list.created | moment("DD MMMM YYYY")}}</td>
							<td>
                                <span v-if="list.deposit_method != '' && list.deposit_method != null && parseInt(list.deposit_method) == 18">-</span>
								<router-link :to="{name: 'fxView.depositTransaction' , query: { 'id': list.transaction_id}}"  title="View" data-placement="top"  data-toggle="tooltip" v-else>
                                    <feather type="eye"></feather>
                                </router-link>
							</td>
                        </tr>
                    </tbody>
                    
                    <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="col_span" :list="depositList" v-else-if="!pageLoader"></loader-component>
                </table>
            </div>
            <div class="border-top ">
                <pagination :getList="depositList" :limit="pageLimit" v-if="depositList.totalRecords > 15"></pagination>
            </div>
        </div>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    import moment from 'moment'
    export default {
        name: 'Dashboard',
        mixins: [fxViewMixins],
        data() {
            return {
                //===========prop in loader component=======
                col_span : 9,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                loaderFuncRun : '1',
                //==========================================
                pageLimit : '15',
                search : '',
                page : '1', 
                pagename : 'deposit-list',
                depositSumUSD: '',
                platform: "",
                platformJson: {
                    MT5: {
                        window:
                            "https://download.mql5.com/cdn/web/fxview.uk.ltd/mt5/fxview5setup.exe?utm_campaign=download.platform&utm_source=global.fxview.com&master_site_id=gyjkxtugcevrzsvxpyrlyetvsbupyvosri",
                        ios: "https://download.mql5.com/cdn/mobile/mt5/ios?utm_campaign=download.platform&utm_source=global.fxview.com&master_site_id=gyjkxtugcevrzsvxpyrlyetvsbupyvosri&server=FXView-Demo,FXView-Live,FXView2-Demo,FXView2-Live",
                        android:
                            "https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5",
                        web: { path: '/web-trade-link', query: { 'platform': 'MT5' } },
                    },
                    MT4: {
                        window:
                            "https://download.mql5.com/cdn/web/fxview.uk.ltd/mt4/fxview4setup.exe",
                        ios: "https://apps.apple.com/us/app/metatrader-4/id496212596",
                        android:
                            "https://play.google.com/store/apps/details?id=net.metaquotes.metatrader4",
                        web: { path: '/new-web-trade-link', query: { 'platform': 'MT4' } },
                    },
                    ACT: {
                        window: "http://setup.sysfx.com/setup/trader/fxview/trader_setup.exe",
                        ios: "https://www.apple.com/ios/app-store/",
                        android:
                            "https://play.google.com/store/apps/details?id=fxview.trader",
                        web: "http://demo.actforex.sysfx.com:8100/trade/actlite.jsp?entry=demo.245",
                    },
                },
            }
        },
        methods:{
            openModal() {
                // $('#exampleModal').modal('show');  // Show modal programmatically
            },
            closeModal() {
                $('#exampleModal').modal('hide');  // Hide modal programmatically
                $('.modal-backdrop').remove();
            },
            listing(){
                if(this.search != ''){
                    this.loaderFuncRun = '0'
                }
                let inputJson = {
                    'globalParams' : {
                        filter: {},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                    } ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
                }

                this._runGetDepositList(inputJson)
            }
        },
        watch: {

        },
        mounted() {
            this.listing();
        },
        created(){
            if(this.$store.getters[Const.GET_DEPOSIT_LIST] != ''){
                this.loaderFuncRun = '0'
            }
            this.listing();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/deposit/deposit_listing.vue